import { useRef } from 'react'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { TableAdapter } from '@makyoapp/makyo-common'

import { TablesDropdownV2 } from '@/components/TablesDropdownV2'

export const TableSelect = ({
  options,
  value,
  onChange,
  error,
  disabled,
}: {
  options: TableAdapter[]
  value?: TableAdapter
  onChange(table: TableAdapter): void
  error?: string | null
  disabled?: boolean
}) => {
  const ref = useRef(null)

  return (
    <div ref={ref} className='flex-1'>
      <TablesDropdownV2
        value={value?.id}
        onChange={(tbl) => onChange(options.find((tb) => tb.id === tbl)!)}
        tables={options}
        menuClassName='w-[300px]'
        showPlaceholder
      />
      <div className='mk-input-error'>{error}</div>
    </div>
  )
}

export const getDefaultColumnValue = (colType: ColumnTypes) => {
  if (
    [
      ColumnTypes.Text,
      ColumnTypes.RichText,
      ColumnTypes.Function,
      ColumnTypes.Formula,
      ColumnTypes.Lookup,
      ColumnTypes.Connection,
      ColumnTypes.Join,
      ColumnTypes.Attachment,
      ColumnTypes.Image,
      ColumnTypes.DateTime,
    ].includes(colType)
  ) {
    return ''
  }

  if (colType === ColumnTypes.Boolean) {
    return false
  }

  if ([ColumnTypes.ImageArray, ColumnTypes.Array, ColumnTypes.MultiSelect].includes(colType)) {
    return []
  }

  return null
}
